module.exports = __webpack_public_path__ + "static/media/a30.5aa599de.pdf";